<template>
    <div>
        <div class="user-headline__container">
            <h1 class="user-headline__title" v-html="$t(title)"></h1>
            <slot></slot>
        </div>
        <p class="user-headline__description" v-html="$t(description)"></p>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            description: String
        }
    }
</script>

<style lang="scss" scoped>
    .user-headline {

        &__container {
            display: flex;
            flex-direction: row;
            gap: 15px;
            align-items: center;
            margin: 16px 0 0;

            [class*="mobile_sm"] & {
                flex-direction: column;
                gap: 0;
                margin-bottom: 30px;
            }
        }

        &__title {
            font-family: QuickSand-Regular, sans-serif;
            font-size: 3.2rem;
            margin: 18px 0;
            font-weight: 400;
        }

        &__description {
            font-family: Nunito-Regular, sans-serif;
            font-size: 1.6rem;
            margin: 0 0 18px;
        }
    }
</style>
